import React, { ReactNode, useContext } from 'react';
import { useDispatch } from 'react-redux';

import { PipeActions } from '../../../redux-store/thunks/pipes.thunks';
import { DatasetActions } from '../../../redux-store/thunks/datasets.thunks';

import { entitiesRefreshed } from '../../../events/entitiesRefreshed.event';

import { DatasetInspectorContext, DatasetInspectorContextArgs } from '../DatasetInspectorContext';

import { DatasetInspectorMessage } from './DatasetInspectorMessage.view';

import type { Dataset } from '../../../types/dataset.types';
import type { DatasetInspectorFilters } from '../../../types/enums';

export const DatasetInspectorMessageContainer: React.FC<{
  dataset: Dataset;
  filter?: DatasetInspectorFilters;
  pipeId: string;
  customActions?: ReactNode[];
  offsetDifference: number;
  populate: () => void;
  stopSearch: () => void;
}> = (props) => {
  const dispatch = useDispatch();

  const { state, entitiesLiveUpdated, isLiveUpdatesEnabled } =
    useContext<DatasetInspectorContextArgs>(DatasetInspectorContext);

  const loadDataset = () => dispatch(DatasetActions.load(props?.dataset._id, true));

  const refreshEntities = () => {
    dispatch(PipeActions.load(props.pipeId));
    props.populate();
    loadDataset();

    entitiesRefreshed.emit();
  };

  return (
    <DatasetInspectorMessage
      {...props}
      state={state}
      entitiesLiveUpdated={entitiesLiveUpdated}
      isLiveUpdatesEnabled={isLiveUpdatesEnabled}
      refreshEntities={refreshEntities}
      offsetDifference={props.offsetDifference}
    />
  );
};
